export enum Role {
  GUEST = 'Guest',
  CUSTOMER = 'Customer',
  PACKER = 'Packer',
  DOCTOR = 'Doctor',
  SHOP_ADMIN = 'Shop admin',
  SUPERADMIN = 'Super admin',
  SALES_MANAGER = 'Sales Manager',
}
